import React, { useMemo } from 'react';
import Toast from 'components/Toast';
import classlist from 'utils/classlist';
import copyMe from 'utils/copyMe';

import './style.scss';

export interface InfoTagProps {
    label: React.ReactNode;
    labelColor?: string;
    content: React.ReactNode;
    contentColor?: string;
    tips?: React.ReactNode;
    className?: string;
    canCopy?: boolean;
}

const InfoTag: React.FC<InfoTagProps> = ({ labelColor, contentColor, label, content, className, canCopy }) => {
    const labelStyles = useMemo(() => {
        const options: any = {};

        if (labelColor) {
            options.color = labelColor;
        }

        return options;
    }, [labelColor]);

    const contentStyles = useMemo(() => {
        const options: any = {};

        if (contentColor) {
            options.color = contentColor;
        }

        return options;
    }, [contentColor]);

    const render = () => {
        return (
            <>
                <label className="info-label" style={labelStyles}>
                    {label}
                </label>
                <span className="info-content" style={contentStyles}>
                    {content}
                </span>
            </>
        );
    };

    const handleCopyBtn = value => {
        Toast.show(copyMe(value) ? __('复制成功！') : __('复制失败，请手动复制'));
    };

    return (
        <div className={classlist('info-tag', className)}>
            {canCopy && typeof content === 'string' ? (
                <>
                    <div>{render()}</div>
                    <span
                        className="copy"
                        onClick={() => {
                            handleCopyBtn(content);
                        }}>
                        {__('Copy')}
                    </span>
                </>
            ) : (
                render()
            )}
        </div>
    );
};

export default InfoTag;
